module.exports = __webpack_public_path__ + "img/agent.0a42422a.png";